/**
 * Site-wide custom events dispatched on `window` for integration scripts
 * (Google Analytics, etc.) to react to.
 *
 * Integration `localScript` strings (see `app/Integrations/*Integration.php`)
 * are plain JS that call `window.addEventListener('<name>', ...)`, so these
 * string values are a cross-language contract — if you rename one here, update
 * every integration that listens for it.
 */
export const SITE_EVENTS = {
  // Cookie-consent decision. Fired by NtCookieConsent when the visitor
  // accepts/declines, and on page load when a stored choice already exists, so
  // listeners can restore consent state on every visit.
  gdprConsented: 'gdpr-consented',
  gdprDenied: 'gdpr-denied',
  // Inertia (SPA) navigation completed — for page-view tracking. detail: { url }.
  routeChanged: 'route-changed',
  // A public-site form was submitted successfully — for conversion tracking.
  // detail: { form, ...context }, where `form` is the current page's name.
  formSubmitted: 'form-submitted',
  // Request to re-open the cookie consent dialog (e.g. from a footer link) so
  // the visitor can change a previously saved choice. NtCookieConsent listens.
  openCookieConsent: 'open-cookie-consent',
}

/**
 * Dispatch a site-wide event that integration scripts can listen for.
 *
 * @param {string} name One of the SITE_EVENTS values.
 * @param {object} [detail] Optional payload exposed as `event.detail`.
 */
export function dispatchSiteEvent(name, detail = {}) {
  if (typeof window === 'undefined') {
    return
  }
  window.dispatchEvent(new CustomEvent(name, { detail }))
}
